<template>
  <div class="min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll">
    <div class="relative flex-1 px-4 sm:px-6">
      <NotificationEditor v-model="notifications" />
    </div>
  </div>
  <div class="flex-shrink-0 px-4 py-4 flex justify-end">
    <button
      type="button"
      class="
        bg-white
        py-2
        px-4
        border border-gray-300
        rounded-md
        shadow-sm
        text-sm
        font-medium
        text-gray-700
        hover:bg-gray-50
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
      "
      @click="$emit('close')"
    >
      Cancel
    </button>
    <button
      type="submit"
      :disabled="hasErrors"
      @click="alertOpen = true"
      class="
        ml-4
        inline-flex
        justify-center
        py-2
        px-4
        border border-transparent
        shadow-sm
        text-sm
        font-medium
        rounded-md
        text-white
        bg-indigo-600
        hover:bg-indigo-700
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
        disabled:opacity-50
      "
    >
      Save
    </button>
  </div>
  <SimpleAlert
    @cancel="alertOpen = false"
    @approve="approve"
    :open="alertOpen"
    title="Apply notification configuration?"
    description="Are you sure you want to apply this notification configuration to all selected devices? All existing configurations will be overwritten. This action cannot be undone."
    action="Apply"
  ></SimpleAlert>
</template>

<script>
import NotificationEditor from "@/components/NotificationEditor";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { updateNotifications } from "@/api/device";
import SimpleAlert from "@/components/modals/Alert";

export default {
  components: {
    NotificationEditor,
    SimpleAlert,
  },
  emits: ["close"],
  props: ["deviceSelection"],

  setup(props, { emit }) {
    const store = useStore();
    const alertOpen = ref(false);
    const notifications = ref([]);

    const hasErrors = computed(
      () => !notifications.value.length || notifications.value.some((destination) => destination.$error !== "")
    );

    return {
      alertOpen,
      notifications,
      hasErrors,
      async approve() {
        alertOpen.value = false;

        await updateNotifications(
          props.deviceSelection,
          notifications.value.map((destination) => ({
            type: destination.type,
            destination: destination.destination,
          }))
        );

        store.dispatch("showNotification", {
          title: "Successfully saved!",
          text: "",
          type: "info",
        });
        emit("close");
      },
    };
  },
};
</script>
